import * as Yup from "yup";
import {object} from "yup";

export const contactValidation = object({
    titel: Yup.string().nullable(),
    funktion: Yup.string().nullable(),
    vorname: Yup.string().required("Vorname erforderlich (zb. Max"),
    nachname: Yup.string().required("Nachname erforderlich (zb. Mustermann)"),
    email: Yup.string().email("Email wurde nicht richtig eingegeben (zb. beispiel@email.at)").required("Email erforderlihc (zb. beispiel@email.at)"),
    namensZusatz: Yup.string().nullable(),
    telbuero: Yup.string().nullable(),
    telmobil: Yup.string().nullable(),
    nachgestellterTitel: Yup.string().nullable(),
})
